import { createContext } from 'react';

import type { Web3State } from './types';

export const Web3StateContext = createContext({} as Web3State);
